import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useSmoothScroll } from "@/motion/useSmoothScroll";
import { ScrollProgress } from "@/components/ScrollProgress";
import { StickyNav } from "@/components/StickyNav";
import { Footer } from "@/components/Footer";
import { Hero } from "@/sections/Hero";
import { About } from "@/sections/About";
import { Speaking } from "@/sections/Speaking";
import { Projects } from "@/sections/Projects";
import { Teaching } from "@/sections/Teaching";
import { Publications } from "@/sections/Publications";
import { WritingList, WritingPost } from "@/sections/Writing";

export function App() {
  useSmoothScroll();
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/writing" element={<WritingList />} />
        <Route path="/writing/:slug" element={<WritingPost />} />
      </Routes>
    </BrowserRouter>
  );
}

function Home() {
  return (
    <>
      <ScrollProgress />
      <StickyNav />
      <main className="relative z-10 min-h-screen">
        <Hero />
        <About />
        <Speaking />
        <Teaching />
        <Publications />
        <Projects />
      </main>
      <Footer />
    </>
  );
}
